import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
   Alert, Button, Container, Form, Row, Col, Nav, NavLink, TabContent, TabPane, Modal, ModalBody, ModalHeader, ModalFooter, FormGroup, Label, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import * as actions from '../actions/Program';
import { clearSearchedPersons, getEditContact, getPerson, searchPersons, setFromAddButton, clearEditContactDetails } from '../actions/Person';
import moment from 'moment';
import * as staticDataActions from '../actions/StaticData';
import { getJurisdictions } from '../actions/Jurisdictions';
import { getGrants, searchGrants } from '../actions/Grants';
import { getProgram, setLocation } from '../actions/Programs';
import { getTraining } from '../actions/Trainings';
import { getUsersByRole } from '../actions/Users';
import { getTrainingFaculty } from '../actions/Training';
import POCList from '../components/poc/List';
import POCModal from '../components/poc/Modal';
import POCEdit from '../components/poc/EditContact';
import classnames from 'classnames';
import Documents from '../components/documents/Documents';
import GridHeader from '../components/common/GridHeader';
import { apiGet } from '../utils/Api';
import Journal from '../components/common/Journal';
import CourtTypes from '../components/common/LookupDropDown';
import Jurisidctions from '../components/common/JurisdictionDropDown';
import Users from '../components/common/UserDropDown';
import Breadcrumb from '../components/MainMenuBreadcrumb';
import TrainingList from '../components/training/TrainingList';
import GrantsList from '../components/common/GrantsList';
import GrantsSearch from '../components/common/GrantsSearch';
import AddGrant from '../components/common/AddGrant';
import { debounce } from 'debounce';
import Address from '../components/common/Address';
import EditContact from '../components/poc/EditContact';

class Program extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            addButtonClicked: false,
            activeTab: null,
            showPOCAdd: false,
            showGrantsSearch: false,
            disableGrantsDelete: true,
            grantId: null,
            confirmModal: false,
            setToPrimaryModal: false,
            selectedContactId: null,
            contactDisplayName: null,
            dropdownOpen: false,
            selectedUser: null,
            projectDirectorId: null,
            traningCoordinatorId: null,
            courtHearingDate: null,
            staffingDate: null,
            projectStartDate: null,
            projectEndDate: null,
            showEndDateBeforeStart: false,
            showAddGrant: null,
            programContactId: null,
            showPOCEdit: false
        }
    }

    componentDidMount() {
        const { id } = this.props.location.state || {};
        const { getCourtTypes, getGrantTypes, getProgramContacts, getProgramJournal, getPhoneTypes, getGrants, getGenerations, getProperTitles, getPersonTypes, getStates, getUsersByRole, getJurisdictions, getAddressTypes } = this.props.actions;
        getCourtTypes();
        if (id !== undefined) {
            getProgramJournal(id);
            getProgramContacts(id)
        }
        getGrantTypes();
        getPhoneTypes();
        getGenerations();
        getProperTitles();
        getPersonTypes();
        getStates();
        getJurisdictions();
        getAddressTypes();
        searchGrants();
        getUsersByRole('');

        if (this.props.history.location.state && this.props.history.location.state.newProgram === true)
            this.setState({ activeTab: 'Info' })
        else if (this.props.location.state?.programId) {
            this.setState({ activeTab: 'Grants' })
        }
        else
            this.setState({ activeTab: 'Notes'})
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({
            dropdownOpen: !prevState.dropdownOpen,
        }));
    };

    handleSelect = (user) => {
        this.setState({ selectedUser: user });
        if (this.props.onSelect) {
            this.props.onSelect(user); // Notify parent component of selection
        }
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.props.actions.setField(name, value);
    }

    handleProjectDirectorDDChange = (e) => {
        const { value } = e.target;
        this.setState({ projectDirectorId: value })
        this.props.actions.setField('projectDirectorId', value);
    }

    handleTrainingCoordinatorDDChange = (e) => {
        const { value } = e.target;
        this.setState({ traningCoordinatorId: value })
        this.props.actions.setField('trainingCoordinatorId', value);
    }

    handleAddressChange = (name, value) => {
        this.props.actions.setAddressField(name, value);
    }

    handlePhoneChange = (value) => {
        this.props.actions.setPhoneField(value);
    }

    handleGrantDDChange = (e) => {
        const { name, value } = e.target;
        this.props.actions.setField(name, value);
        this.setState({ grantId: value })
    }

    handleSave = (projectStartDate, projectEndDate) => {
        if (projectEndDate < projectStartDate)
            this.setState({ showEndDateBeforeStart: true })
        else
            this.props.actions.updateProgram(this.props.program);
    }

    handleDocumentsClick = () => this.props.actions.getProgramDocuments(this.props.program.get('programId'));

    handleAddFiles = (type, files) => this.props.actions.addProgramDocument(this.props.program.get('programId'), type || this.props.documentTypes[0].lookupId, files);

    handleDocumentDelete = (ids) => this.props.actions.deleteProgramDocuments(this.props.program.get('programId'), ids);

    handleDocumentSave = (programDocumentId, documentTypeId) => this.props.actions.updateProgramDocument(this.props.programId, programDocumentId, documentTypeId);

    handleToggleTab = (tab) => {
        const programId = this.props.program.get('programId');

        if (tab === 'Documents') {
            this.props.actions.getProgramDocuments(programId);
            this.props.actions.getProgramDocumentTypes();
        }

        if (tab === 'Contacts') {
            this.props.actions.getProgramContacts(programId);
        }

        if (tab === 'Grants') {
            this.props.actions.getProgramGrants(programId);
        }
        if (tab === 'Info') {
            this.props.actions.getProgram(programId);
        }

        if (tab === 'Notes') {
            this.props.actions.getProgramJournal(programId);
        }

        if (tab === 'Trainings') {
            this.props.actions.getProgramTrainings(this.props.currentSessionId, programId);
        }

        this.setState({ activeTab: tab });
    }

    handleTogglePOCAdd = () => {
        this.props.actions.setFromAddButton()
        this.setState({ showPOCAdd: !this.state.showPOCAdd });
    }

    handleTogglePOCEdit = () => {
        this.setState({ showPOCEdit: !this.state.showPOCEdit });
    }

    handleDeleteContacts = (ids) => this.props.actions.deleteProgramContacts(this.props.program.get('programId'), ids);

    handleAddContact = (contact) => {
        const programId = this.props.program.get('programId');
        const fromEdit = contact.fromEdit === true ? true : false;
        if (fromEdit) {
            this.props.actions.addProgramContact(programId, { isPrimary: contact.isPrimary, programContactId: this.state.programContactId, programId, person: contact, isActive: true });
        }
        else 
            this.props.actions.addProgramContact(programId, { programId, person: contact, isActive: true });
        this.setState({ programContactId: null })
    }

    handleGrantsOnSelectionChanged = (ids) => {
        this.selectedGrantIds = ids;
        this.setState({ disableGrantsDelete: ids.length > 0 ? false : true })
    }

    handleAddContactFromSearch = (persons) => {
        const programId = this.props.program.get('programId');
        const contacts = persons.map(x =>
        (
            {
                programId,
                personId: x.personId,
                isActive: true
            }
        )
        );

        this.props.actions.addProgramContacts(programId, contacts);
    }

    handleGrantsSearchToggle = () => {
        this.setState({ showGrantsSearch: !this.state.showGrantsSearch });
    }

    handleGrantsSearchOnAdd = (grantIds) => {
        this.props.actions.addProgramGrants(this.props.program.get('programId'), grantIds);
    }

    handleGrantsOnDelete = () => {
        this.props.actions.deleteProgramGrants(this.props.program.get('programId'), this.selectedGrantIds);
        this.setState({ disableGrantsDelete: true })
    }

    handlePersonSelect = (id) => {
        this.props.actions.getPerson(id);
        this.props.history.push(`/persons/person/${id}`);
    }

    setProgramContactId = async (id) => {
        this.setState({
            programContactId: id
            })
    }

    makePrimary = async (params) => {
        if (params.row.isPrimary === true) {
            this.setState({
                confirmModal: true,
                selectedContactId: params.row.programContactId,
                contactDisplayName: params.row.displayName
            });
        }
        else {
            this.setState({
                setToPrimaryModal: true,
                selectedContactId: params.row.programContactId,
                contactDisplayName: params.row.displayName
            });
        }
    };

    handleSaveProgramJournalEntry = (journalEntry) => {
        const programId = this.props.program.get('programId');
        const programJournalEntry =
            journalEntry.id ?
                {
                    programId,
                    programJournalEntryId: journalEntry.id,
                    isActive: true,
                    ...journalEntry
                }
                :
                {
                    programId,
                    isActive: true,
                    ...journalEntry
                };

        return this.props.actions.saveProgramJournalEntry(programId, programJournalEntry);
    }

    handleGetProgramJournalEntry = (programJournalEntryId) =>
        apiGet(`${process.env.REACT_APP_API_HOST}api/program/journal/${programJournalEntryId}`)
            .then(res => ({ ...res, id: res.programJournalEntryId }));

    handleDeleteProgramJournalEntries = (ids) => this.props.actions.deleteProgramJournalEntries(this.props.program.get('programId'), ids);

    handleTrainingOnSelect = (trainingId) => {
        this.props.actions.getTraining(trainingId);
        this.props.actions.getTrainingFaculty(trainingId);
        this.props.history.push({
            pathname: `/trainings/training/${trainingId}`
        });
    }

    handleGrantSearchToggle = () => {
        this.props.actions.clearSearchedGrants();
        this.setState({ showGrantsSearch: !this.state.showGrantsSearch });
    }

    handleAddGrantToggle = () => {
        this.props.actions.clearSearchedGrants();
        this.setState({ showAddGrant: !this.state.showAddGrant });
    }

    handleGrantSearch = (text) => {
        const { programId } = this.props.program.toJS();
        this.throttledSearch(programId, text);
    }

    handleGrantDoubleClick = (e) => {
        this.props.history.push({
            pathname: `/grants/grant/${e.id}`,
            state: { fromProgramId: this.props.program.get('programId') }
        });
    };

    handleCourtHearingDateChange = (e) => {
        const { name, value } = e.target;
        this.setState({ name: value })
        this.props.actions.setField('courtHearingDate', value);
    }

    handleStaffingDateChange = (e) => {
        const { name, value } = e.target;
        this.setState({ name: value })
        this.props.actions.setField('staffingDate', value);
    }

    handleProjectStartDateChange = (e) => {
        const {name, value } = e.target;
        this.setState({ name: value })
        this.props.actions.setField('projectStartDate', value);
    }

    handleProjectEndDateChange = (e) => {
        const { value } = e.target;
        this.setState({ name: value })
        this.props.actions.setField('projectEndDate', value);
    }

    onDismissShowEndDateBeforeStartDate = () => {
        this.setState({ showEndDateBeforeStart: !this.state.showEndDateBeforeStart });
    }

    handdleTogglePocListFromAdd = () => {
        this.props.actions.setFromAddButton(true)
        this.setState({ showPOCAdd: true });
    }

    onEdit = (id) => {
        this.props.actions.setFromAddButton(false)
        this.props.actions.getEditContact(id).then(() => {
            this.setState({ showPOCEdit: true });
        });
    }

    throttledSearch = debounce((programId, searchTerm) => this.props.actions.searchGrants(programId, searchTerm), 500);

    render() {
        const { addressTypes, contactNameIsValid, contactPhoneIsValid, contactPersonTypeIsValid, phoneTypes, users, states, documents, program,
            courtTypes, jurisdictions, programDataContacts, personTypes, generations, properTitles, personSearchResults, journal } = this.props;
        const { courtTypeId, jurisdictionId, programId, contacts, name, address, trainingCoordinatorId, projectDirectorId, courtHearingDate, staffingDate, projectStartDate, projectEndDate } = program.toJS();
        const doesJurisdictionExist = jurisdictions.filter(e => e.jurisdictionId === Number(jurisdictionId))
        const jurisdictionValueToUse = doesJurisdictionExist.length > 0 ? jurisdictionId : undefined
        const filterPrimaryContact = programDataContacts && programDataContacts.toJS().filter(e => e.isPrimary === true)
        const filterPrimaryContactPhone = (filterPrimaryContact && filterPrimaryContact[0]?.phone) || ''
        const filterPrimaryContactName = (filterPrimaryContact && filterPrimaryContact[0]?.displayName) || ''
        const filterPrimaryContectEmail = (filterPrimaryContact && filterPrimaryContact[0]?.email) || ''
          return (
            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={this.props.history} />
                </div>
                <Alert color="warning" isOpen={this.state.showEndDateBeforeStart} fade={true} toggle={this.onDismissShowEndDateBeforeStartDate}>
                    Project end date cannot occur before project start date.
                </Alert>
                  <br />
                  {this.state.showPOCAdd && <POCModal
                      modalTitle={'Add a Point of Contact'}
                      toggleValidState={this.props.actions.toggleValidState}
                      toggleContactPhoneIsValid={this.props.actions.toggleContactPhoneIsValid}
                      contactPhoneIsValid={contactPhoneIsValid}
                      clearEditContactDetails={this.props.actions.clearEditContactDetails}
                      contactNameIsValid={contactNameIsValid}
                      contactPersonTypeIsValid={contactPersonTypeIsValid}
                      isOpen={this.state.showPOCAdd}
                      toggle={this.handleTogglePOCAdd}
                      states={states}
                      phoneTypes={phoneTypes.toJS()}
                      properTitles={properTitles}
                      generations={generations}
                      personTypes={personTypes}
                      addressTypes={addressTypes.toJS()}
                      onAdd={this.handleAddContact}
                  />}
                  {this.state.showPOCEdit && <POCEdit
                      modalTitle={'Edit a Point of Contact'}
                      toggleValidState={this.props.actions.toggleValidState}
                      toggleContactPhoneIsValid={this.props.actions.toggleContactPhoneIsValid}
                      contactPhoneIsValid={contactPhoneIsValid}
                      clearEditContactDetails={this.props.actions.clearEditContactDetails}
                      contactNameIsValid={contactNameIsValid}
                      contactPersonTypeIsValid={contactPersonTypeIsValid}
                      isOpen={this.state.showPOCEdit}
                      toggle={this.handleTogglePOCEdit}
                      states={states}
                      phoneTypes={phoneTypes.toJS()}
                      properTitles={properTitles}
                      generations={generations}
                      personTypes={personTypes}
                      addressTypes={addressTypes.toJS()}
                      onAdd={this.handleAddContact}
                  />}
                <Form>
                    <Nav tabs>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'Notes' })}
                            onClick={() => { this.handleToggleTab('Notes'); }}
                            disabled={!programId}
                        >
                            Journal
                        </NavLink>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'Info' })}
                            onClick={() => { this.handleToggleTab('Info'); }}
                        >
                            Info
                        </NavLink>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'Contacts' })}
                            onClick={() => { this.handleToggleTab('Contacts'); }}
                            disabled={!programId}
                        >
                            Contacts
                        </NavLink>
                        {/*<NavLink*/}
                        {/*    className={classnames({ active: this.state.activeTab === 'Documents' })}*/}
                        {/*    onClick={() => { this.handleToggleTab('Documents'); }}*/}
                        {/*    disabled={!programId}*/}
                        {/*>*/}
                        {/*    Documents*/}
                        {/*</NavLink>*/}
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'Grants' })}
                            onClick={() => { this.handleToggleTab('Grants'); }}
                            disabled={!programId}
                        >
                            Grants
                        </NavLink>
                        {/*<NavLink*/}
                        {/*    className={classnames({ active: this.state.activeTab === 'Trainings' })}*/}
                        {/*    onClick={() => { this.handleToggleTab('Trainings'); }}*/}
                        {/*    disabled={!programId}*/}
                        {/*>*/}
                        {/*    Trainings*/}
                        {/*</NavLink>*/}
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="Info">
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label>Name:</Label>
                                        <Input name='name' type='text' invalid={!name} value={name || ''} onChange={this.handleChange} />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <CourtTypes
                                        label='Court Type'
                                        name='courtTypeId'
                                        dropdownPlaceholder='Select'
                                        lookups={courtTypes}
                                        value={courtTypeId}
                                        onChange={this.handleChange}
                                    />
                                </Col>
                                <Col>
                                    <Jurisidctions
                                        name='jurisdictionsId'
                                        dropdownPlaceholder='Select'
                                        jurisdictions={jurisdictions}
                                        value={jurisdictionValueToUse}
                                        onChange={this.handleChange}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Address
                                    states={this.props.states}
                                    name='address'
                                    onChange={this.handleAddressChange}
                                    city={address?.city}
                                    stateId={address?.stateId}
                                    zipCode={address?.zipCode}
                                    line1={address?.line1}
                                    line2={address?.line2}
                                ></Address>
                            </Row>
                            <Row>
                                <Col>
                                    <Users
                                        titleToUse='Project Director'
                                        name='projectDirectorId'
                                        dropdownPlaceholder='Select'
                                        users={users.toJS()}
                                        onChange={this.handleProjectDirectorDDChange}
                                        value={projectDirectorId  }
                                    />
                                </Col>
                                <Col>
                                    <Users
                                        titleToUse='Training Coordinator'
                                        name='trainingCoordinatorId'
                                        dropdownPlaceholder='Select'
                                        users={users.toJS()}
                                        onChange={this.handleTrainingCoordinatorDDChange}
                                        value={trainingCoordinatorId}
                                    />
                                </Col>
                            </Row>
                            <Row style={{paddingTop: '1em'}}>
                                <Col>
                                    <Label>Primary Contact:</Label>
                                    <br/>
                                      <Label>
                                          {filterPrimaryContactName}
                                    </Label>
                                </Col>
                                <Col>
                                    <Label>Primary Phone:</Label>
                                    <br/>
                                      <Label>
                                          {filterPrimaryContactPhone}
                                    </Label>
                                </Col>
                                <Col>
                                    <Label>Email:</Label>
                                    <br/>
                                      <Label>
                                          {filterPrimaryContectEmail}
                                    </Label>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: '1em' }}>
                                <Col>
                                    <Label style={{ paddingLeft: '5px' }}>Project Start Date:</Label>
                                    <Input type='datetime-local' max="2999-12-31T23:59" name='projectStartDate' onChange={(e) => this.handleProjectStartDateChange(e)} value={projectStartDate || this.state.projectStartDate} />
                                </Col>
                                <Col>
                                    <Label style={{ paddingLeft: '5px' }}>Project End Date:</Label>
                                    <Input type='datetime-local' max="2999-12-31T23:59" name='projectEndDate' onChange={(e) => this.handleProjectEndDateChange(e)} value={projectEndDate || this.state.projectEndDate} />
                               </Col>
                                <Col>
                                    <Label style={{ paddingLeft: '5px' }}>Staffing Date:</Label>
                                    <Input type='datetime-local' max="2999-12-31T23:59" name='staffingDate' onChange={(e) => this.handleStaffingDateChange(e)} value={staffingDate || this.state.staffingDate} />
                                </Col>
                                <Col>
                                    <Label style={{ paddingLeft: '5px' }}>Court Hearing Date:</Label>
                                    <Input type='datetime-local' max="2999-12-31T23:59" name='courtHearingDate' onChange={(e) => this.handleCourtHearingDateChange(e)} value={courtHearingDate || this.state.courtHearingDate} />
                                </Col>
                            </Row>
                        </TabPane>
                    </TabContent>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="Contacts">
                            <Row className='pt-3'>
                                <Col>
                                      <POCList
                                        setProgramContactId={this.setProgramContactId}
                                        fromContactGrid={true}
                                        makePrimary={this.makePrimary}
                                        data={programDataContacts.toJS()}
                                        programId={programId}
                                        clearSearchedPersons={this.props.actions.clearSearchedPersons}
                                        onEdit={(id) => this.onEdit(id)}
                                        onAdd={this.handdleTogglePocListFromAdd}
                                        onDelete={this.handleDeleteContacts}
                                        onSelect={this.handlePersonSelect}
                                        onSearch={this.props.actions.searchPersons}
                                        searchResults={personSearchResults}
                                        onAddFromSearch={this.handleAddContactFromSearch}
                                    />
                                </Col>
                            </Row>
                        </TabPane>
                    </TabContent>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="Documents">
                            <Row className='pt-3'>
                                <Col>
                                    <Documents
                                        title='Program Documents:'
                                        documentTypes={this.props.documentTypes}
                                        onSave={this.handleDocumentSave}
                                        onAddFiles={this.handleAddFiles}
                                        onTypeChange={this.handleDocumentTypeChange}
                                        onDownload={this.handleDocumentDownload}
                                        onDelete={this.handleDocumentDelete}
                                        data={documents && documents.toJS()}
                                        getEntityId={(x) => x.programDocumentId}
                                    />
                                </Col>
                            </Row>
                        </TabPane>
                    </TabContent>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="Grants">
                            <Row className='pt-3'>
                                <GridHeader
                                    gridEntities='Grants'
                                    showSearch={true}
                                    searchButtonId='searchGrantButton'
                                    onSearch={this.handleGrantSearchToggle}
                                    onDeleteClick={this.handleGrantsOnDelete}
                                    disableDelete={this.state.disableGrantsDelete}
                                    addButtonId='addGrantButton'
                                    deleteButtonId='deleteGrantButton'
                                    onAddClick={this.handleAddGrantToggle}
                                    addTooltipTarget={'addGrantButton'}
                                    deleteTooltipTarget={'deleteGrantButton'}
                                    tooltipEntity={'Grant'}
                                />
                            </Row>
                            <GrantsList
                                onSelectionChanged={this.handleGrantsOnSelectionChanged}
                                onRowDoubleClick={this.handleGrantDoubleClick}
                                data={this.props.programGrants}
                                programId={programId}
                            />
                            <GrantsSearch
                                onSearch={this.handleGrantSearch}
                                grants={this.props.grants}
                                isOpen={this.state.showGrantsSearch}
                                toggle={this.handleGrantSearchToggle}
                                onAdd={this.handleGrantsSearchOnAdd}
                                data={this.props.searchedGrants}
                            />
                            <AddGrant
                                programId={this.props.program.get('programId') }
                                onSearch={this.handleGrantSearch}
                                isOpen={this.state.showAddGrant}
                                toggle={this.handleAddGrantToggle}
                                onAdd={this.handleGrantsSearchOnAdd}
                                data={this.props.searchedGrants}
                                grantTypes={this.props.grantTypes}
                                sessionId={this.props.currentSessionId}
                                setField={this.props.actions.setField()}
                            />
                        </TabPane>
                    </TabContent>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="Notes">
                            <Row className='pt-3'>
                                <Col>
                                    <Journal
                                        title=' '
                                        data={journal.toJS()}
                                        onGet={this.handleGetProgramJournalEntry}
                                        onSave={this.handleSaveProgramJournalEntry}
                                        onDelete={this.handleDeleteProgramJournalEntries}
                                        journalTypes={this.props.journalTypes}
                                        journalStatusTypes={this.props.journalStatusTypes}
                                    />
                                </Col>
                            </Row>
                        </TabPane>
                    </TabContent>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="Trainings">
                            <Row className='pt-3'>
                                <Col>
                                    <TrainingList
                                        data={this.props.trainings}
                                        onSelect={this.handleTrainingOnSelect}
                                    />
                                </Col>
                            </Row>
                        </TabPane>
                    </TabContent>
                    {this.state.activeTab === 'Info' &&
                        <Row className='pt-1'>
                            <Col>
                                <Button className={'float-right'} disabled={!courtTypeId || !name || !jurisdictionId} onClick={() => this.handleSave(projectStartDate, projectEndDate)}>Save</Button>
                            </Col>
                        </Row>
                    }
                </Form>
                  <Modal isOpen={this.state.confirmModal} toggle={() => this.setState({ confirmModal: false, addButtonClicked: false })} className={this.props.className}>
                      <ModalHeader toggle={() => this.setState({ confirmModal: false })}>Remove Primary Contact</ModalHeader>
                    <ModalBody>
                        This will remove {this.state.contactDisplayName} as the primary contact for this program.
                    </ModalBody>
                    <ModalFooter>
                          <Button color="primary" onClick={() => {
                            this.props.actions.addPrimaryContact(this.state.selectedContactId, this.props.program.get('programId'))
                              this.setState({ confirmModal: false})
                        }}>Ok</Button>
                        <Button color="secondary" onClick={() => this.setState({ confirmModal: false })}>Cancel</Button>
                    </ModalFooter>
                  </Modal>
                  <Modal isOpen={this.state.setToPrimaryModal} toggle={() => this.setState({ setToPrimaryModal: false, addButtonClicked: false })} className={this.props.className}>
                      <ModalHeader toggle={() => this.setState({ confirmModal: false })}>Remove Primary Contact</ModalHeader>
                      <ModalBody>
                          This will set the a primary contact to {this.state.contactDisplayName} for this program.
                      </ModalBody>
                      <ModalFooter>
                          <Button color="primary" onClick={() => {
                              this.props.actions.addPrimaryContact(this.state.selectedContactId, this.props.program.get('programId'))
                              this.setState({ setToPrimaryModal: false })
                          }}>Ok</Button>
                          <Button color="secondary" onClick={() => this.setState({ setToPrimaryModal: false })}>Cancel</Button>
                      </ModalFooter>
                  </Modal>
            </Container>

        );
    }
}

function mapStateToProps(state) {
    return {
        programId: state.ProgramData.getIn(['program', 'programId']),
        addressTypes: state.StaticData.get('addressTypes'),
        contactPhoneIsValid: state.ProgramData.get('phoneNumberIsValid'),
        contactNameIsValid: state.ProgramData.get('contactNameIsValid'),
        contactPersonTypeIsValid: state.ProgramData.get('contactPersonTypeIsValid'),
        program: state.ProgramData.get('program'),
        programDataContacts: state.ProgramData.get('contacts'),
        documents: state.ProgramData.get('documents'),
        journalTypes: state.StaticData.get('journalTypes').toJS(),
        documentTypes: state.StaticData.get('programDocumentTypes').toJS(),
        courtTypes: state.StaticData.get('courtTypes').toJS(),
        journalStatusTypes: state.StaticData.get('journalStatusTypes').toJS(),
        phoneTypes: state.StaticData.get('phoneTypes'),
        properTitles: state.StaticData.get('properTitles').toJS(),
        generations: state.StaticData.get('generations').toJS(),
        personTypes: state.StaticData.get('personTypes').toJS(),
        states: state.StaticData.get('states').toJS(),
        jurisdictions: state.Jurisdictions.toJS(),
        grants: state.Grants.toJS(),
        fromTrainingPage: state.ProgramData.get('fromTrainingPage'),
        fromTrainingId: state.ProgramData.get('fromTrainingId'),
        person: state.PersonData.get('person').toJS(),
        currentSessionId: parseInt(state.login.getIn(['context', 'user', 'claims'])
            .find(x => x.get('claimType') === 'ACT.CurrentSession').get('claimValue'), 10),
        personSearchResults: state.SearchResults.get('persons').toJS(),
        journal: state.ProgramData.get('journal'),
        trainings: state.ProgramData.get('trainings').toJS(),
        programGrants: state.ProgramData.get('programGrants'),
        searchedGrants: state.ProgramData.get('searchedGrants'),
        users: state.Users.get('userList'),
        grantTypes: state.StaticData.get('grantTypes').toJS(),
        fromAddButton: state.PersonData.get('fromAddButton'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...actions,
            ...staticDataActions,
            clearSearchedPersons,
            clearEditContactDetails,
            getTraining,
            getTrainingFaculty,
            getProgram,
            getJurisdictions,
            setLocation,
            searchGrants,
            getGrants,
            getEditContact,
            getPerson,
            searchPersons,
            setFromAddButton,
            getUsersByRole
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Program);